import { functionDoc } from '../functionDoc';
import { ROLES, SHOTS } from '../docHelpers';

/** Documentación detallada (plantilla 12 apartados) de cada función del menú Gestión. */
export const gestionSections = [
  functionDoc({
    
      "id": "gestion-clasificacion-inicio",
      "name": "Clasificación de productos — inicio",
      "type": "screen",
      "route": "/classification",
      "locationPath": "Gestión > Clasificación > Inicio",
      "generalDescription": "Panel de entrada a la clasificación de productos: enlaces a categorías, subcategorías, familias y vista jerárquica. Organiza el catálogo para reportes y filtros.",
      "prerequisites": [
        "Módulo Gestión visible."
      ],
      "interfaceElements": [
        {
          "name": "Accesos rápidos",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Navegación a cada mantenedor.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Gestión → Clasificación → Inicio.",
        "Elija la vista a mantener."
      ],
      "practicalExample": {
        "context": "Nuevo analista de catálogo.",
        "data": {},
        "steps": [
          "Entrar a inicio",
          "Ir a Categorías"
        ]
      },
      "validations": [],
      "expectedResult": [
        "Navegación clara hacia mantenedores de clasificación."
      ],
      "commonErrors": [],
      "relatedFunctions": [
        "gestion-clasificacion-categorias",
        "gestion-clasificacion-jerarquia"
      ],
      "observations": [],
      "screenshots": [
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
    
  }),

  functionDoc({
    
      "id": "gestion-clasificacion-categorias",
      "name": "Productos — categorías",
      "type": "list",
      "route": "/classification/categories",
      "locationPath": "Gestión > Clasificación > Productos — Categorías",
      "generalDescription": "Mantenimiento del primer nivel de clasificación de productos. Cada producto debe asociarse a una rama válida categoría → subcategoría → familia.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Código, nombre y estado de categorías.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nueva categoría",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "",
          "behavior": ""
        },
        {
          "name": "Nombre",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "En modal o formulario inline.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Menú lateral Compras → Productos — Categorías.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-clasificacion-subcategorias",
        "gestion-productos-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-clasificacion-subcategorias",
      "name": "Productos — subcategorías",
      "type": "list",
      "route": "/classification/subcategories",
      "locationPath": "Gestión > Clasificación > Productos — Subcategorías",
      "generalDescription": "Segundo nivel jerárquico bajo una categoría. Obligatorio para asignar familias y productos.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Productos — Subcategorías.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-clasificacion-categorias",
        "gestion-clasificacion-familias"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-clasificacion-familias",
      "name": "Productos — familias",
      "type": "list",
      "route": "/classification/families",
      "locationPath": "Gestión > Clasificación > Productos — Familias",
      "generalDescription": "Tercer nivel de clasificación de productos. Se elige al crear o editar productos en Gestión → Productos.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Productos — Familias.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-clasificacion-jerarquia",
        "gestion-productos-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-clasificacion-jerarquia",
      "name": "Productos — vista jerárquica",
      "type": "screen",
      "route": "/classification/hierarchy",
      "locationPath": "Gestión > Clasificación > Productos — Vista jerárquica",
      "generalDescription": "Árbol categoría → subcategoría → familia para revisar la estructura completa y detectar ramas vacías o mal asignadas.",
      "prerequisites": [
        "Categorías creadas previamente."
      ],
      "interfaceElements": [
        {
          "name": "Árbol expandible",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": true,
          "description": "Nodos clicables para editar según pantalla.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Abra la vista jerárquica.",
        "Expanda nodos.",
        "Corrija en pantallas de categorías si falta un nivel."
      ],
      "practicalExample": {
        "context": "Auditoría de catálogo.",
        "data": {},
        "steps": [
          "Revisar árbol",
          "Completar familias faltantes"
        ]
      },
      "validations": [],
      "expectedResult": [
        "Visión consolidada de la taxonomía de productos."
      ],
      "commonErrors": [
        {
          "error": "Rama vacía",
          "cause": "Sin familias creadas.",
          "solution": "Cree familias bajo la subcategoría."
        }
      ],
      "relatedFunctions": [
        "gestion-clasificacion-familias"
      ],
      "observations": [],
      "screenshots": [
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
    
  }),

  functionDoc({
    
      "id": "gestion-servicios-categorias",
      "name": "Servicios — categorías",
      "type": "list",
      "route": "/classification/services/categories",
      "locationPath": "Gestión > Clasificación > Servicios — Categorías",
      "generalDescription": "Primer nivel de clasificación de servicios cuando servicesClassificationEnabled está activo.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Servicios — Categorías.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-servicios-subcategorias",
        "gestion-servicios-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => ctx.settings?.servicesClassificationEnabled
  }),

  functionDoc({
    
      "id": "gestion-servicios-subcategorias",
      "name": "Servicios — subcategorías",
      "type": "list",
      "route": "/classification/services/subcategories",
      "locationPath": "Gestión > Clasificación > Servicios — Subcategorías",
      "generalDescription": "Subcategorías de servicios vinculadas a categoría padre.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Servicios — Subcategorías.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-servicios-familias"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => ctx.settings?.servicesClassificationEnabled
  }),

  functionDoc({
    
      "id": "gestion-servicios-familias",
      "name": "Servicios — familias",
      "type": "list",
      "route": "/classification/services/families",
      "locationPath": "Gestión > Clasificación > Servicios — Familias",
      "generalDescription": "Familias de servicios para reportes y filtros en OS de compra/venta.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Servicios — Familias.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-servicios-jerarquia"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => ctx.settings?.servicesClassificationEnabled
  }),

  functionDoc({
    
      "id": "gestion-servicios-jerarquia",
      "name": "Servicios — vista jerárquica",
      "type": "screen",
      "route": "/classification/services/hierarchy",
      "locationPath": "Gestión > Clasificación > Servicios — Vista jerárquica",
      "generalDescription": "Árbol de clasificación de servicios paralelo al de productos.",
      "prerequisites": [
        "servicesClassificationEnabled activo."
      ],
      "interfaceElements": [
        {
          "name": "Árbol de servicios",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": true,
          "description": "Árbol",
          "behavior": ""
        }
      ],
      "procedure": [
        "Gestión → Clasificación → Servicios — Vista jerárquica.",
        "Revise ramas."
      ],
      "practicalExample": null,
      "validations": [],
      "expectedResult": [
        "Estructura de servicios visible de un vistazo."
      ],
      "commonErrors": [],
      "relatedFunctions": [
        "gestion-servicios-categorias"
      ],
      "observations": [],
      "screenshots": [
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
    ,
    isVisible: (ctx) => ctx.settings?.servicesClassificationEnabled
  }),

  functionDoc({
    
      "id": "gestion-entidades-list",
      "name": "Entidades — listado",
      "type": "list",
      "route": "/entities",
      "locationPath": "Gestión > Entidades",
      "generalDescription": "Personas y empresas genéricas del sistema para usos transversales (distintas de proveedores de compras o clientes de ventas según configuración).",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Entidades.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-entidades-create",
        "gestion-entidades-edit"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-entidades-create",
      "name": "Entidades — nueva",
      "type": "form",
      "route": "/entities/create",
      "locationPath": "Gestión > Entidades > Nueva",
      "generalDescription": "Registro de entidad con código, nombre y datos de identificación según campos de la pantalla.",
      "prerequisites": [
        "Acceso a Gestión con permiso de escritura (no limitado solo lectura)."
      ],
      "interfaceElements": [
        {
          "name": "Código",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Texto",
          "behavior": ""
        },
        {
          "name": "Nombre",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Texto",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "gestion-entidades-list"
      ],
      "observations": [
        "Revise impacto en kardex antes de cambiar unidades o conversiones."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-entidades-edit",
      "name": "Entidades — edición",
      "type": "form",
      "route": "/entities/:id/edit",
      "locationPath": "Gestión > Entidades > Editar",
      "generalDescription": "Actualización de entidad existente; evite cambiar códigos usados en integraciones.",
      "prerequisites": [
        "Acceso a Gestión con permiso de escritura (no limitado solo lectura)."
      ],
      "interfaceElements": [
        {
          "name": "Datos generales",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Formulario",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "gestion-entidades-list"
      ],
      "observations": [
        "Revise impacto en kardex antes de cambiar unidades o conversiones."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-productos-list",
      "name": "Productos — listado",
      "type": "list",
      "route": "/products",
      "locationPath": "Gestión > Productos",
      "generalDescription": "Catálogo de productos inventariables: código, nombre, unidad, clasificación y flags de IGV/proyecto.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Productos.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-productos-create",
        "gestion-productos-edit"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-productos-create",
      "name": "Productos — nuevo",
      "type": "form",
      "route": "/products/create",
      "locationPath": "Gestión > Productos > Nuevo",
      "generalDescription": "Alta de producto: código único, nombre, unidad de medida, clasificación, costos y atributos. Base del kardex y compras.",
      "prerequisites": [
        "Acceso a Gestión con permiso de escritura (no limitado solo lectura)."
      ],
      "interfaceElements": [
        {
          "name": "Código",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Texto",
          "behavior": ""
        },
        {
          "name": "Nombre",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Texto",
          "behavior": ""
        },
        {
          "name": "Unidad de medida",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Select",
          "behavior": ""
        },
        {
          "name": "Clasificación",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Select jerárquico",
          "behavior": ""
        },
        {
          "name": "IGV / proyecto",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Según módulos activos.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "gestion-productos-list",
        "gestion-config-unidades"
      ],
      "observations": [
        "Revise impacto en kardex antes de cambiar unidades o conversiones."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-productos-edit",
      "name": "Productos — edición",
      "type": "form",
      "route": "/products/:id/edit",
      "locationPath": "Gestión > Productos > Editar",
      "generalDescription": "Modificación de producto existente. Cambiar unidad o conversiones puede afectar kardex; coordine con almacén.",
      "prerequisites": [
        "Acceso a Gestión con permiso de escritura (no limitado solo lectura)."
      ],
      "interfaceElements": [
        {
          "name": "Secciones del formulario",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Generales, clasificación, atributos, imagen.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "gestion-productos-list",
        "gestion-sunat-mappings"
      ],
      "observations": [
        "Revise impacto en kardex antes de cambiar unidades o conversiones."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-servicios-list",
      "name": "Servicios — listado",
      "type": "list",
      "route": "/services",
      "locationPath": "Gestión > Servicios",
      "generalDescription": "Catálogo de servicios para OS de compra, OSV, producción y listas de precio.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Servicios.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-servicios-create",
        "gestion-servicios-edit"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-servicios-create",
      "name": "Servicios — nuevo",
      "type": "form",
      "route": "/services/create",
      "locationPath": "Gestión > Servicios > Nuevo",
      "generalDescription": "Alta de servicio con nombre, unidad de cobro y clasificación de servicios si está habilitada.",
      "prerequisites": [
        "Acceso a Gestión con permiso de escritura (no limitado solo lectura)."
      ],
      "interfaceElements": [
        {
          "name": "Nombre",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Texto",
          "behavior": ""
        },
        {
          "name": "Unidad",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Select",
          "behavior": ""
        },
        {
          "name": "Clasificación servicio",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Si servicesClassificationEnabled.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "gestion-servicios-list"
      ],
      "observations": [
        "Revise impacto en kardex antes de cambiar unidades o conversiones."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-servicios-edit",
      "name": "Servicios — edición",
      "type": "form",
      "route": "/services/:id/edit",
      "locationPath": "Gestión > Servicios > Editar",
      "generalDescription": "Actualiza servicio existente usado en documentos; nombre visible en PDFs y pantallas operativas.",
      "prerequisites": [
        "Acceso a Gestión con permiso de escritura (no limitado solo lectura)."
      ],
      "interfaceElements": [
        {
          "name": "Nombre y unidad",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Campos",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "gestion-servicios-list"
      ],
      "observations": [
        "Revise impacto en kardex antes de cambiar unidades o conversiones."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "gestion-sunat-mappings",
      "name": "Relación Productos SUNAT",
      "type": "screen",
      "route": "/sunat-mappings",
      "locationPath": "Gestión > Relación Productos SUNAT",
      "generalDescription": "Vincula cada producto interno con códigos o tipos de afectación SUNAT para facturación electrónica y reportes tributarios.",
      "prerequisites": [
        "Productos dados de alta.",
        "Criterios definidos por contador."
      ],
      "interfaceElements": [
        {
          "name": "Buscador producto",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Texto",
          "behavior": ""
        },
        {
          "name": "Código / tipo SUNAT",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Texto o select",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "",
          "behavior": ""
        }
      ],
      "procedure": [
        "Gestión → Relación Productos SUNAT.",
        "Busque producto.",
        "Complete relación y guarde."
      ],
      "practicalExample": {
        "context": "Nuevo insumo facturable.",
        "data": {
          "Producto": "INS-001"
        },
        "steps": [
          "Buscar",
          "Asignar código catálogo SUNAT",
          "Guardar"
        ]
      },
      "validations": [
        "Un producto puede requerir un solo mapeo activo según reglas."
      ],
      "expectedResult": [
        "Emisiones electrónicas usan el código asignado."
      ],
      "commonErrors": [
        {
          "error": "Código inválido",
          "cause": "Catálogo SUNAT desactualizado.",
          "solution": "Valide con contador y tabla vigente."
        }
      ],
      "relatedFunctions": [
        "gestion-productos-edit",
        "compras-sunatalias-limitado"
      ],
      "observations": [],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear."
      ],
      "roles": "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
    
  }),

  functionDoc({
    
      "id": "gestion-config-inicio",
      "name": "Configuración — inicio",
      "type": "screen",
      "route": "/configuration",
      "locationPath": "Gestión > Configuración",
      "generalDescription": "Índice de parámetros maestros: unidades, almacenes, proyectos, POS y más. Solo administradores; usuarios limitados no acceden a /configuration.",
      "prerequisites": [
        "Rol administrador."
      ],
      "interfaceElements": [
        {
          "name": "Enlaces a submódulos",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Unidades, conversiones, atributos, etc.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Gestión → Configuración.",
        "Elija el parámetro a mantener."
      ],
      "practicalExample": null,
      "validations": [],
      "expectedResult": [
        "Navegación a pantallas de configuración."
      ],
      "commonErrors": [
        {
          "error": "Acceso denegado",
          "cause": "Usuario limitado.",
          "solution": "Use cuenta administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-config-unidades"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "gestion-config-unidades",
      "name": "Unidades de medida",
      "type": "form",
      "route": "/configuration/units",
      "locationPath": "Gestión > Configuración > Unidades de medida",
      "generalDescription": "Catálogo de unidades (KG, UND, LT, etc.) usadas en productos, guías y documentos.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Unidades de medida.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-config-conversiones",
        "gestion-productos-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "gestion-config-conversiones",
      "name": "Conversiones de unidad",
      "type": "form",
      "route": "/configuration/conversions",
      "locationPath": "Gestión > Configuración > Conversiones",
      "generalDescription": "Factores entre unidades del mismo producto (ej. caja → unidad).",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Conversiones.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-config-unidades"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "gestion-config-atributos",
      "name": "Atributos de producto",
      "type": "form",
      "route": "/configuration/attributes",
      "locationPath": "Gestión > Configuración > Atributos",
      "generalDescription": "Campos personalizados opcionales en fichas de producto.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Atributos.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-productos-edit"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "gestion-config-almacenes",
      "name": "Almacenes (configuración)",
      "type": "form",
      "route": "/configuration/warehouses",
      "locationPath": "Gestión > Configuración > Almacenes",
      "generalDescription": "Define almacenes físicos o lógicos para kardex y restricciones por usuario limitado.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Almacenes.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-config-areas"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "gestion-config-proyectos",
      "name": "Proyectos",
      "type": "form",
      "route": "/configuration/projects",
      "locationPath": "Gestión > Configuración > Proyectos",
      "generalDescription": "Centros de costo o proyectos para imputar compras, ventas y productos si productsProjectEnabled.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Proyectos.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-productos-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "gestion-config-areas",
      "name": "Áreas",
      "type": "form",
      "route": "/configuration/areas",
      "locationPath": "Gestión > Configuración > Áreas",
      "generalDescription": "Áreas organizativas usadas en requerimientos, activos y reportes.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Áreas.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-config-hitos"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "gestion-config-hitos",
      "name": "Hitos",
      "type": "form",
      "route": "/configuration/milestones",
      "locationPath": "Gestión > Configuración > Hitos",
      "generalDescription": "Hitos de proyecto o cronograma según implementación de su empresa.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Hitos.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-config-proyectos"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "gestion-config-series",
      "name": "Series autonumeradas",
      "type": "form",
      "route": "/configuration/document-number-series",
      "locationPath": "Gestión > Configuración > Series autonumeradas",
      "generalDescription": "Series y correlativos para documentos internos (OC, OS, guías, etc.) según tipos configurados.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Series autonumeradas.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "compras-oc-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "gestion-config-pos",
      "name": "Puntos de venta",
      "type": "form",
      "route": "/configuration/point-of-sales",
      "locationPath": "Gestión > Configuración > Puntos de venta",
      "generalDescription": "POS para ventas comerciales, series y producción concesionaria.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Puntos de venta.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "gestion-config-almacenes"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "gestion-config-sedes-compra",
      "name": "Sedes de compra",
      "type": "form",
      "route": "/configuration/purchase-sites",
      "locationPath": "Gestión > Configuración > Sedes de compra",
      "generalDescription": "Sedes que segmentan requerimientos, OC y reportes cuando comprasPurchaseSitesEnabled.",
      "prerequisites": [
        "Acceso al módulo Gestión (administrador o limitado con Gestión habilitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Sedes de compra.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "compras-select-sede",
        "compras-sede-historico"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global.",
        "Cambios en catálogos impactan compras, almacenes y ventas."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => !ctx.isLimitedUser && ctx.settings?.comprasPurchaseSitesEnabled
  }),
];
